import angular from 'angular'
import financialReport from './financialReport'
import creatIncomeTax from './creatIncomeTax'

export default angular
    .module('declaration.incomeTax', [financialReport, creatIncomeTax])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('declaration.incomeTax', {
            abstract: true,
            url: '/incomeTax',
            template: '<div ui-view></div>',
            title: '所得税',
        })
    }])
    .name



// WEBPACK FOOTER //
// ./src/app/declaration/incomeTax/index.js